var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { FormattedMessage } from "@irati/utils/lang";
import IconButton from "../Button/IconButton";
import RangeInput from "./RangeInput";
import { Label3 } from "../Labels";
import padding from "../global/padding";
import Flex from "../Flex";
import Scale from "./styled/Scale";
var SCALE_ABSOLUTE_MINIMUM = 0.25;
var SCALE_MINIMUM_UPPER_LIMIT = 0.3;
var SCALE_ABSOLUTE_MAXIMUM = 1.5;
var SCALE_MAXIMUM_LOWER_LIMIT = 1.45;
var AMOUNT_T0_SCALE = 5;
var ScaleInput = /** @class */ (function (_super) {
    __extends(ScaleInput, _super);
    function ScaleInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.updateLogoScale = function (value) {
            var scale = value / 100;
            _this.props.onUpdate(scale);
        };
        _this.decreaseLogoScale = function () {
            /* if the user tries to decrease the scale value and the current value is greater than the SCALE_ABSOLUTE_MINIMUM
             * but greater by a value less than 0.5 then just set the scale to the SCALE_ABSOLUTE_MINIMUM
             * else decrease the scale value by 0.5 as we've not already reached the SCALE_ABSOLUTE_MINIMUM */
            var _a = _this.props, imageScale = _a.imageScale, onUpdate = _a.onUpdate;
            if (imageScale > SCALE_ABSOLUTE_MINIMUM) {
                if (imageScale <= SCALE_MINIMUM_UPPER_LIMIT) {
                    onUpdate(SCALE_ABSOLUTE_MINIMUM);
                }
                else {
                    onUpdate((imageScale * 100 - AMOUNT_T0_SCALE) / 100);
                }
            }
        };
        _this.increaseLogoScale = function () {
            var _a = _this.props, imageScale = _a.imageScale, onUpdate = _a.onUpdate;
            if (imageScale < SCALE_ABSOLUTE_MAXIMUM) {
                if (imageScale >= SCALE_MAXIMUM_LOWER_LIMIT) {
                    onUpdate(SCALE_ABSOLUTE_MAXIMUM);
                }
                else {
                    onUpdate((imageScale * 100 + AMOUNT_T0_SCALE) / 100);
                }
            }
        };
        return _this;
    }
    ScaleInput.prototype.render = function () {
        var _a = this.props, imageScale = _a.imageScale, landscapeIcon = _a.landscapeIcon, centerSlider = _a.centerSlider;
        return (React.createElement(React.Fragment, null,
            React.createElement(Label3, { uppercase: true },
                React.createElement(FormattedMessage, { id: "account.formItem.slider.labelThree" })),
            React.createElement(Flex, { justifyContent: centerSlider ? "center" : "flex-start", alignItems: "center", width: "200px", margin: centerSlider ? "0 auto " + padding.base : "24px 0" },
                landscapeIcon ? (React.createElement(IconButton, { icon: "landscape", size: "20", onClick: this.decreaseLogoScale })) : (React.createElement(Scale, { direction: "right", onClick: this.decreaseLogoScale }, "-")),
                React.createElement(RangeInput, { width: 200, value: imageScale * 100, onUpdateValue: this.updateLogoScale }),
                landscapeIcon ? (React.createElement(IconButton, { icon: "landscape", size: "35", onClick: this.increaseLogoScale })) : (React.createElement(Scale, { direction: "left", onClick: this.increaseLogoScale }, "+")))));
    };
    ScaleInput.defaultProps = {
        landscapeIcon: false,
        centerSlider: false
    };
    return ScaleInput;
}(Component));
export default ScaleInput;
